import { type ReactElement } from 'react'
import SafeTxProvider from '@/components/tx-flow/SafeTxProvider'
import { TxInfoProvider } from '@/components/tx-flow/TxInfoProvider'
import { TxSecurityProvider } from '@/components/tx/security/shared/TxSecurityContext'

type TransactionLayout = {
  children: ReactElement
}

const TransactionLayout = ({ children }: TransactionLayout) => {
  return (
    <SafeTxProvider>
      <TxInfoProvider>
        <TxSecurityProvider>{children}</TxSecurityProvider>
      </TxInfoProvider>
    </SafeTxProvider>
  )
}

export default TransactionLayout
